import { FC } from 'react';
import { CustomerCatalogueContainer } from '../CustomerCatalogueContainer';
import CustomerBundles from './CustomerBundles';

export const CustomerBundlesPage: FC = () => {
  return (
    <CustomerCatalogueContainer>
      <CustomerBundles />
    </CustomerCatalogueContainer>
  );
};
